import {useNotify} from "nvd-u/composables/Notifiy";
import i18n from "../locales/translations";

export function parseJwt(token) {
    try {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (e) {
        console.log('error while parsing token', e)
        return null
    }
}

/**
 * Writes text to the system clipboard. Uses the Clipboard API when allowed,
 * otherwise falls back to execCommand (needed on some HTTP origins / older browsers).
 */
export async function copyPlainText(text: string): Promise<boolean> {
    const value = typeof text === 'string' ? text : ''
    if (!value) return false
    try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(value)
            return true
        }
    } catch {
        /* fall through */
    }
    try {
        const ta = document.createElement('textarea')
        ta.value = value
        ta.setAttribute('readonly', '')
        ta.style.position = 'fixed'
        ta.style.left = '-9999px'
        ta.style.top = '0'
        document.body.appendChild(ta)
        ta.focus()
        ta.select()
        const ok = document.execCommand('copy')
        document.body.removeChild(ta)
        return ok
    } catch {
        return false
    }
}

export async function copyText(text, header, subheader) {
    const notify = useNotify()
    const ok = await copyPlainText(text)
    if (ok) {
        // @ts-ignore
        notify.success(i18n.global.t(`dialog.${header}`), i18n.global.t(`dialog.${subheader}`))
    } else {
        notify.error(
            i18n.global.t('dialog.copy_failed_title'),
            i18n.global.t('dialog.copy_failed_generic')
        )
    }
}

export function showSimpleToast(text, duration = 3000) {
    let div = document.createElement('div')
    div.style = `
                padding: 0.5em;
                background-color: var(--dark);
                color: var(--bg);
                position: fixed;
                right: 1em;
                top: 1em;
                z-index: 999;
                border-radius: 0.5em;
                box-shadow: var(--shadow)
            `
    div.textContent = text
    document.body.append(div)
    setTimeout(() => {
        div.remove()
    }, duration)
}

export function _debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export function _sleep(milliseconds) {
    return new Promise(resolve => {
        setTimeout(resolve, milliseconds)
    })
}

export function _deepClone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

export class DebounceFn {
    timer = null
    delay = 0

    constructor(delay) {
        this.delay = delay
    }

    run(fn) {
        clearTimeout(this.timer)
        this.timer = setTimeout(fn, this.delay)
    }
}

export function randomInt(from, to) {
    return Math.floor((Math.random() + from) * to)
}

export function cssVar(variable, value) {
    let r = document.querySelector(':root')
    if (value) {
        return r.style.setProperty(variable, value)
    }
    let rs = getComputedStyle(r)
    return rs.getPropertyValue(variable)
}


export function isValidLink(value) {
    const pattern = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/
    return pattern.test(value)
}
